<template lang="pug">
el-date-picker(:value='inner_value', @input='update', type='date', :clearable='clearable', :editable='editable', :disabled='disabled', :readonly='readonly', :size='size', :placeholder='placeholder', :pickerOptions='options')
</template>

<script>
export default {
  name: 'datepicker',
  props: {
    value: null,
    min: null,
    max: null,
    placeholder: String,
    clearable: Boolean,
    editable: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    size: String,
    sortcuts: Array,
    strict: Boolean,
  },
  data() {
    return {
      inner_value: undefined,
    }
  },
  computed: {
    options() {
      return {
        sortcuts: this.sortcuts,
        disabledDate: (date) => {
          if (this.local_max && date > this.local_max)
            return true
          if (this.local_min && date < this.local_min)
            return true
        },
      }
    },
    local_max() {
      return this.$formatters.date.to_local(this.max)
    },
    local_min() {
      return this.$formatters.date.to_local(this.min)
    },
  },
  watch: {
    max() {
      if (this.strict && this.max && this.inner_value > this.max)
        this.inner_value = this.max
    },
    min() {
      if (this.strict && this.min && this.inner_value < this.min)
        this.inner_value = this.min
    },
    value(to, from) {
      if (!to || !from || +to !== +from) // Convert date to timestamp
        this.init()
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.inner_value = this.$formatters.date.to_local(this.value) || new Date()
    },
    update(to) {
      this.inner_value = to
      this.$emit('input', this.$formatters.date.to_utc(to))
    },
  },
}
</script>



// WEBPACK FOOTER //
// Datepicker.vue?3a6f3169